export default __webpack_public_path__ + "static/O0036-a83356f919f25c5efa61c7ff28845d2c.png";